import { useEffect } from 'react';

/**
 * Sets document title and meta description for the current page (SEO).
 * Restores default when component unmounts.
 */
export const usePageSEO = (title, description) => {
  const defaultTitle = 'GoToBusiness | Mobile App Development, Website Development & Software Development - Noida';
  const defaultDescription = 'GoToBusiness - Top mobile application development, website development & software development company in Noida. Custom web apps, iOS & Android apps. Get free quote.';

  useEffect(() => {
    if (title) {
      document.title = title;
    }
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc && description) {
      metaDesc.setAttribute('content', description);
    }
    return () => {
      document.title = defaultTitle;
      if (metaDesc) {
        metaDesc.setAttribute('content', defaultDescription);
      }
    };
  }, [title, description]);
};
